import wrapWithProvider from './wrap_with_provider';
export const wrapRootElement = wrapWithProvider;
